import Button, { ButtonSize } from "@ui/atoms/Button"
import clsx from "clsx"
import React, { ReactNode } from "react"

export interface Cta {
  label: ReactNode
  onClick: () => void
  loading?: boolean
  disabled?: boolean
  hidden?: boolean
}

export type CtaAlign = "left" | "right"

export interface CancelConfirmCtaProps {
  cancel?: Cta
  confirm?: Cta
  size?: ButtonSize
  className?: string
  align?: CtaAlign
}

const CancelConfirmCta = ({
  confirm,
  cancel,
  size,
  className,
  align,
}: CancelConfirmCtaProps) => {
  return (
    <div
      className={clsx(
        "flex gap-2",
        {
          "justify-start": align === "left",
          "justify-end": align === "right",
        },
        className
      )}
    >
      {cancel && !cancel.hidden && (
        <Button
          size={size}
          disabled={cancel.disabled}
          loading={cancel.loading}
          onClick={cancel.onClick}
          color="light"
        >
          {cancel.label}
        </Button>
      )}
      {confirm && !confirm.hidden && (
        <Button
          size={size}
          disabled={confirm.disabled}
          loading={confirm.loading}
          onClick={confirm.onClick}
          color="primary"
        >
          {confirm.label}
        </Button>
      )}
    </div>
  )
}

export default CancelConfirmCta
